//#region types
import { DateHelper } from "utils/helpers";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion

/**
 * @deprecated This service is deprecated. Use useStoppedPaymentsService hook instead.
 *
 * @see useStoppedPaymentsService - The replacement hook
 * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
 */
const StoppedPaymentsService = {
  getDueDate: (stoppedPayments?: WintSuperkollAPIModel.StoppedPayments) => {
    if (stoppedPayments === undefined) return new Date();
    let dueDate = DateHelper.getDateMax();

    stoppedPayments.stoppedPaymentList?.forEach((stoppedPayment) => {
      if (stoppedPayment.dueDate && DateHelper.isBefore(new Date(stoppedPayment.dueDate), dueDate))
        dueDate = stoppedPayment.dueDate;
    });

    return dueDate;
  },
};

export default StoppedPaymentsService;
